// 创建自定义 history 对象
import { createBrowserHistory } from 'history'

const customHistory = createBrowserHistory()

export { customHistory }
